// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import {
  updateHighlightedPaths,
  updatePaths,
  updateVisiblePathIds,
} from 'redux/modules/projectSummary'

// removes the specified path ids from highlight and from visibility
// this is called when a project is split and we need to remove the split paths
// or when paths are deleted from the project,
// this is also called when a path is deleted from the path details form

const removeMultiplePaths = pathsToRemove => (dispatch, getState) => {
  const { projectSummary } = getState()

  const removePaths = (a, d, i) => {
    // if this pathid 'd' is not in the pathsToRemove list, then don't remove it
    if (!~pathsToRemove.indexOf(d)) {
      a.push(d)
    }
    return a
  }

  // new sets with the pathsToRemove paths to removed
  const highlightedPaths = projectSummary.get('highlightedPaths').reduce(removePaths, [])
  const visiblePathIds = projectSummary.get('visiblePathIds').reduce(removePaths, [])

  // filter the path summaries to reflect the paths to remove
  // and update their path indexes
  const paths = projectSummary.get('paths').reduce((a, d, i) => {
    if (!~pathsToRemove.indexOf(d.get('pathId'))) {
      a.push(d)
    }
    return a
  }, []).map((d, i) => d.set('pathIndex', i + 1))

  // update the lists which tell UI how to render the paths
  dispatch(updateHighlightedPaths(highlightedPaths))
  dispatch(updateVisiblePathIds(visiblePathIds))
  dispatch(updatePaths(paths))
}

export default removeMultiplePaths
